<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  methods:{
    
  }
}
</script>

<style scoped>
  

</style>
